import * as types from '../../mutation-types'
import * as api from '../../api'
import router from '../../../router'

const state = {
  command_result: '',
  intercom_external_sip: [],
  intercom_external_sips: [],
  intercom_external_sips_received_timestamp: new Date(0)
}

const getters = {
  commandResult: state => state.command_result,
  singleIntercomExternalSip: state => state.intercom_external_sip,
  allIntercomExternalSips: state => state.intercom_external_sips
}

const actions = {
  executeCommand ({ commit, rootGetters }, command) {
    let site, machineType

    switch (command) {
      case '1':
        command = 'sofia status'
        break
      case '2':
        command = 'reloadxml'
        break
      case '3':
        machineType = rootGetters.machineType

        if (machineType === 'Box') {
          site = rootGetters.allSites.find(function (ele) {
            if (ele.site_id === rootGetters.scopedSiteId) {
              return ele
            }
          })
          command = 'sofia status profile ' + site.ip + ' reg'
        } else if (machineType === 'Cloud') {
          command = 'sofia status profile internal reg'
        }

        break
      case '4':
        machineType = rootGetters.machineType

        if (machineType === 'Box') {
          site = rootGetters.allSites.find(function (ele) {
            if (ele.site_id === rootGetters.scopedSiteId) {
              return ele
            }
          })
          command = 'sofia status profile ' + site.ip + ' reg minimal'
        } else if (machineType === 'Cloud') {
          command = 'sofia status profile internal reg minimal'
        }
        break
      case '5':
        command = 'show calls'
        break
      case '6':
        command = 'stop all calls'
        break
      case '7':
        command = 'reload mod_sofia'
        break
      case '8':
        command = 'show calls minimal'
        break
    }
    let dataToSend = {
      command: command
    }
    api.instance.post('intercom_command', dataToSend)
      .then(function (response) {
        let result = response.data.result.replace(/(?:\\[rn])+/g, '').replace(/(?:\\[rt])+/g, '   ')
        commit(types.RECEIVE_COMMAND_RESULT, result)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getIntercomExternalSips ({ commit }) {
    const diff = Math.abs(new Date(state.intercom_external_sips_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('intercom_external_sips')
        .then(function (response) {
          const intercomExternalSips = response.data.intercom_external_sips
          commit(types.RECEIVE_INTERCOM_EXTERNAL_SIPS, intercomExternalSips)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getIntercomExternalSip ({ commit }, intercomExternalSipId) {
    api.instance.get('intercom_external_sips/' + intercomExternalSipId)
      .then(function (response) {
        const intercomExternalSip = response.data.intercom_external_sip
        commit(types.RECEIVE_INTERCOM_EXTERNAL_SIP, intercomExternalSip)
      })
  },
  addEditIntercomExternalSip ({ commit, rootGetters }, intercomExternalSip) {
    intercomExternalSip.site_id = rootGetters.scopedSiteId

    if (intercomExternalSip.intercom_external_sip_id === 0) {
      api.instance.post('intercom_external_sips', intercomExternalSip)
        .then(function (response) {
          if (response.data.success === 'true') {
            intercomExternalSip = response.data.intercom_external_sip[0]
            commit(types.ADD_INTERCOM_EXTERNAL_SIP, intercomExternalSip)
            router.push({ name: 'AdminExternalSipIndex' })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      api.instance.put('intercom_external_sips/' + intercomExternalSip.intercom_external_sip_id, intercomExternalSip)
        .then(function (response) {
          if (response.data.success === 'true') {
            intercomExternalSip = response.data.intercom_external_sip[0]
            commit(types.EDIT_INTERCOM_EXTERNAL_SIP, intercomExternalSip)
            router.push({ name: 'AdminExternalSipIndex' })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deleteIntercomExternalSip ({ commit }, intercomExternalSip) {
    api.instance.delete('intercom_external_sips/' + intercomExternalSip.intercom_external_sip_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_INTERCOM_EXTERNAL_SIP, intercomExternalSip)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_COMMAND_RESULT] (state, result) {
    state.command_result = result
  },
  [types.ADD_INTERCOM_EXTERNAL_SIP] (state, intercomExternalSip) {
    state.intercom_external_sips.push(intercomExternalSip)
  },
  [types.EDIT_INTERCOM_EXTERNAL_SIP] (state, intercomExternalSip) {
    let intercomExternalSipToEdit = state.intercom_external_sips.find(
      function (ele) {
        if (ele.intercom_external_sip_id === intercomExternalSip.intercom_external_sip_id) {
          return true
        }
      }
    )
    let index = state.intercom_external_sips.indexOf(intercomExternalSipToEdit)
    state.intercom_external_sips[index] = intercomExternalSip
  },
  [types.DELETE_INTERCOM_EXTERNAL_SIP] (state, intercomExternalSip) {
    let intercomExternalSipToDelete = state.intercom_external_sips.find(
      function (ele) {
        if (ele.intercom_external_sip_id === intercomExternalSip.intercom_external_sip_id) {
          return true
        }
      }
    )
    let index = state.intercom_external_sips.indexOf(intercomExternalSipToDelete)
    state.intercom_external_sips.splice(index, 1)
  },
  [types.RECEIVE_INTERCOM_EXTERNAL_SIP] (state, intercomExternalSip) {
    state.intercom_external_sip = intercomExternalSip
  },
  [types.RECEIVE_INTERCOM_EXTERNAL_SIPS] (state, intercomExternalSips) {
    state.intercom_external_sips = intercomExternalSips
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
